module.exports = __webpack_public_path__ + "026dc6a741995dfdfa0329cc0ee80e7f.png";